import { CloseButton, Modal } from "react-bootstrap"
import { PageInfo } from "Components/PageInformation/PageInformation";
import { useEffect } from "react";
import { ga_log_popup } from "Utils/GA4/GTM";
import { TextButton } from "Components/Button";

const Popup = ({
  showPopup,
  handlePopup,
  handleClose,
  popupMsg,
  resetStateValue,
  variant,
  combo
}) => {

    useEffect(()=>{
        if(showPopup==true){
            ga_log_popup(variant, popupMsg);
        }
    },[showPopup])

    const formatContactHelp = (show, msg) =>{
        return (
            show == false
            ?   msg
            :   <>
                    {msg} Please contact the PSOPPC Help Desk at <a href="mailto:support@psoppc.org">support@psoppc.org</a> to report the issue.
                </>
        )
    }

  const modalBody2 = (variant) => {
    
    switch (variant) {
      case "error":
        
        return (
          <>
            {
              Array.isArray(popupMsg.msg) == true
                ?
                popupMsg["msg"].map((msg) => {
                  return (
                    <PageInfo
                      type="error"
                      message={
                        popupMsg.showContactHelp == false
                          ? msg
                          : <>
                            {msg}
                            &nbsp;Please contact the PSOPPC Help Desk at&nbsp;
                            <a href="mailto:support@psoppc.org">support@psoppc.org</a>&nbsp;
                            to report the issue.
                          </>
                      }
                      classes="mt-2"
                    >
                    </PageInfo>
                  )
                })
                :
                <PageInfo
                  type="error"
                  message={
                    popupMsg.showContactHelp == false
                      ? popupMsg.msg
                      : <>
                        {popupMsg.msg}
                        &nbsp;Please contact the PSOPPC Help Desk at&nbsp;
                        <a href="mailto:support@psoppc.org">support@psoppc.org</a>&nbsp;
                        to report the issue.
                      </>
                  }
                >
                </PageInfo>
            }

           
          </>
        );
      case "success":
        return (
          <PageInfo
            type="success"
            message={
              popupMsg.msg
            }
          ></PageInfo>
          
        );
      case "warning":
        return (
          <PageInfo
            type="warning"
            message={
              popupMsg.msg
            }
          ></PageInfo>
        );
      case "batch_error":
        return (
          <PageInfo
            type="batch_error"
            message={
              popupMsg.msg
            }
          ></PageInfo>
        );
      default:
        return (
          <PageInfo
            type="info"
            message={
              popupMsg.msg
            }
          ></PageInfo>
        );
    }
  }

  const modalBody = (variant, message) => {
    
    var title = popupMsg.title;
    if(message==null){
        message = popupMsg.msg;
    }
    switch (variant) {
        case "error":
          return (
            
            <PageInfo
                type="error"
                message={
                    formatContactHelp(popupMsg.showContactHelp,message)
                }
                combo={combo}
                title={title}
            >
            </PageInfo>

          );
        case "success":
          return (
            <PageInfo
                type="success"
                message={
                    message
                }
                combo={combo}
                title={title}
            ></PageInfo>
            
          );
        case "warning":
          return (
            <PageInfo
                type="warning"
                message={
                    formatContactHelp(popupMsg.showContactHelp,message)
                }
                combo={combo}
                title={title}
            ></PageInfo>
          );
        case "batch_error":
          return (
            <PageInfo
                type="batch_error"
                message={
                    formatContactHelp(popupMsg.showContactHelp,message)
                }
                combo={combo}
                title={title}
            ></PageInfo>
          );
        case "blank":
            return (
                formatContactHelp(popupMsg.showContactHelp,message)
            );
        default:
          return (
            <PageInfo
                type="info"
                message={
                    message
                }
                combo={combo}
                title={title}
            ></PageInfo>
           
          );
        }
    }

  return (
    <>
      <Modal className="modal" size="lg" backdrop="static" keyboard={false} show={showPopup} onHide={handleClose}>
        {/* <Modal.Header>
          <Modal.Title >{popupMsg.title}</Modal.Title>
          <CloseButton className="align-self-start" onClick={handleClose}></CloseButton>
        </Modal.Header> */}
        <Modal.Header className={combo!=null ? "mb-3 mb-md-2" : ""}>
          {
            combo!=null 
            ?   null
            :   <Modal.Title >{popupMsg.title}</Modal.Title>
          }
          
          <CloseButton className="align-self-start" onClick={handleClose}></CloseButton>
        </Modal.Header>
        <Modal.Body>
          {
            
            Array.isArray(popupMsg.msg) == true
                ?   popupMsg["msg"].map((msg) => {
                        return (
                            modalBody(variant, msg)
                        )
                    })
                :   modalBody(variant)
          }
        </Modal.Body>
        <Modal.Footer className={combo!=null ? "mb-3 mb-md-0" : ""}>
          <TextButton onClick={handleClose} variant="comp-primary" size={"lg"} className="w-xs-100 w-md-fit-content" content="OK" autoFocus>
          </TextButton>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default Popup;